import TeamArt from "../../../assets/imgs/team-art.svg";

const UserList = ({ title, users, message }) => (
  <div className="mb-4 w-full">
    <h3 className="font-bold text-lg mb-2">{title}</h3>
    <p className="mb-2">{message}</p>
    <ul className="list-none bg-gray-100/70 dark:bg-gray-700/30 border border-gray-50 dark:border-gray-700/50 rounded-lg py-2 px-4 w-full max-w-full">
      {users.map((user, index) => (
        <li
          key={index}
          className="font-semibold dark:text-gray-300 w-full"
          title={user?.email}
        >
          {user?.email}
          {!user?.success && user?.reason && (
            <ul className="list-disc list-inside">
              <li className="text-red-500">{user.reason}</li>
            </ul>
          )}
        </li>
      ))}
    </ul>
  </div>
);

const NewUsersReceipt = ({ receiptData, isPartOfOrganization }) => {
  let { existing, newUsers } = receiptData;

  const messageNewUsers = isPartOfOrganization
    ? "These users have had accounts created automatically and were added to your team:"
    : "These users have been invited to create a Scribenote account and join your team:";

  const messageExistingUsers = isPartOfOrganization
    ? "These Scribenote users were added to your team:"
    : "These Scribenote users were invited to join your team:";

  const failedUsers = [...newUsers, ...existing].filter(
    (u) => !u.success,
  );
  newUsers = newUsers.filter((u) => u.success);
  existing = existing.filter((u) => u.success);

  return (
    <div className="flex flex-row items-center space-x-4 w-full overflow-hidden">
      <img
        src={TeamArt}
        className="w-1/4 object-contain"
        alt="Team Art"
      />
      <div className="flex-1 overflow-hidden">
        {newUsers?.length > 0 && (
          <UserList
            title={`New Scribenote Users ${
              isPartOfOrganization ? "Added" : "Invited"
            }`}
            users={newUsers}
            message={messageNewUsers}
          />
        )}

        {existing?.length > 0 && (
          <UserList
            title={`Existing Scribenote Users ${
              isPartOfOrganization ? "Added" : "Invited"
            }`}
            users={existing}
            message={messageExistingUsers}
          />
        )}

        {failedUsers?.length > 0 && (
          <UserList
            title={`Failed invites`}
            users={failedUsers}
            message={"These invites failed to send"}
          />
        )}
      </div>
    </div>
  );
};

export default NewUsersReceipt;
